export var IdShopOpenSource;
(function (IdShopOpenSource) {
    IdShopOpenSource[IdShopOpenSource["UNKNOWN"] = -1] = "UNKNOWN";
    IdShopOpenSource[IdShopOpenSource["HUD_OFFER"] = 0] = "HUD_OFFER";
    IdShopOpenSource[IdShopOpenSource["ADD_GOLD_BUTTON"] = 1] = "ADD_GOLD_BUTTON";
    IdShopOpenSource[IdShopOpenSource["FORCED_OFFER"] = 2] = "FORCED_OFFER";
    IdShopOpenSource[IdShopOpenSource["MISSING_GOLD"] = 3] = "MISSING_GOLD";
    IdShopOpenSource[IdShopOpenSource["MISSING_OFFER_ONLY_ITEM"] = 4] = "MISSING_OFFER_ONLY_ITEM";
    IdShopOpenSource[IdShopOpenSource["QUEST_SHOWME"] = 5] = "QUEST_SHOWME";
    IdShopOpenSource[IdShopOpenSource["STORE"] = 6] = "STORE";
    IdShopOpenSource[IdShopOpenSource["TUTORIAL_END"] = 7] = "TUTORIAL_END";
})(IdShopOpenSource || (IdShopOpenSource = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/shop/IdShopOpenSource.ts
// module id = 556
// module chunks = 3